import modelBaseV2 from "../model-base-v2.model"

const UploadUserManualModel = {
    getUserManual: (params) => {
        return modelBaseV2.post('/api/user/userManual/search', { body: params })
    },

    uploadUserManual: (menuId, params) => {
        return modelBaseV2.post(`/api/user/userManual/upload/${menuId}`, { body: params })
    },

    downloadUserManual: (fileId, fileName) => {
        return modelBaseV2.getDownload('/api/user/file/:fileId', { params: { fileId } }, fileName)
    }
}
export default UploadUserManualModel    